"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SSRDataUtilities = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _modelsConstants = require("./modelsConstants");

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var SSRDataUtilities = /*#__PURE__*/function () {
  function SSRDataUtilities() {
    (0, _classCallCheck2.default)(this, SSRDataUtilities);
  }

  (0, _createClass2.default)(SSRDataUtilities, null, [{
    key: "processSSRData",
    value: // private static jwtTimer: NodeJS.Timer;

    /**
     * Will call the right functions to
     * decrypt the jwt tokens
     */
    function processSSRData(ssrData, ssrDataJson) {
      var _this = this;

      if (!ssrData || !ssrDataJson) {
        return;
      }

      var ssrDataTkn = new _modelsConstants.SSRDataTkn();
      ssrData.ssr_data.forEach(function (ssr) {
        if (!ssr) {
          return;
        }

        var algorithmUsed = _this.identifyAlgorithm(ssr.ssrgroup, ssrDataJson);

        if (!_modelsConstants.ALGORITHMS[algorithmUsed]) {
          return;
        }

        var algo = (0, _toConsumableArray2.default)(_modelsConstants.ALGORITHMS[algorithmUsed]);

        var reversedAlgo = _this.reverseArray(algo);

        if (!reversedAlgo) {
          return;
        }

        var decryptedSSRData = _this.executeAlgorithm(reversedAlgo, ssr.ssrlist);

        if (!decryptedSSRData) {
          return;
        }

        var apiSource = ssrDataJson.api_data.find(function (api) {
          return api.id === ssr.source;
        });

        if (!apiSource) {
          return;
        }

        var ssrTknKey = Object.keys(ssrDataTkn).find(function (tokenKey) {
          return tokenKey === apiSource.source;
        });

        if (ssrTknKey) {
          ssrDataTkn[ssrTknKey] = decryptedSSRData;
        }
      }); // this.monitorJWTExpiration(ssrDataTkn);

      return ssrDataTkn.available_dates;
    }
    /**
     *
     * @param algorithmAlias
     *
     * Will identify the algorithm to be used based
     * on the alias given by the api response
     */

  }, {
    key: "identifyAlgorithm",
    value: function identifyAlgorithm(algorithmAlias, ssrDataJson) {
      if (!algorithmAlias) {
        return;
      }

      if (!ssrDataJson) {
        return;
      }

      if (!ssrDataJson.synonyms) {
        return;
      }

      var algoSynonyms = ssrDataJson.synonyms;
      var algorithmUsed;

      var _iterator = _createForOfIteratorHelper(algoSynonyms),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var synonym = _step.value;

          if (!synonym) {
            continue;
          }

          var synonymAlgo = synonym.value.find(function (algo) {
            return algo === algorithmAlias;
          });

          if (!synonymAlgo) {
            continue;
          }

          algorithmUsed = synonym.name;
          return algorithmUsed;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     *
     * @param data
     *
     * Will get the authorization bearer token
     */

  }, {
    key: "getToken",
    value: function getToken(data) {
      if (!data) {
        return;
      }

      data = data.reverse();
      var token = data.join('');
      token = this.decode64(token);
      return "".concat(_modelsConstants.BEARER).concat(token);
    }
    /**
     *
     * @param input
     *
     */

  }, {
    key: "decode64",
    value: function decode64(input) {
      // eslint-disable-next-line no-useless-concat
      var keyStr = 'ABCDEFGHIJKLMNOP' + 'QRSTUVWXYZabcdef' + 'ghijklmnopqrstuv' + 'wxyz0123456789+/' + '=';
      var output = '';
      var chr1;
      var chr2;
      var chr3;
      var enc1;
      var enc2;
      var enc3;
      var enc4;
      var i = 0; // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
      // eslint-disable-next-line no-useless-escape

      var base64test = /[^A-Za-z0-9\+\/\=]/g;

      if (base64test.exec(input)) {//   alert(
        //     'There were invalid base64 characters in the input text.\n' +
        //       "Valid base64 characters are A-Z, a-z, 0-9, '+', '/',and '='\n" +
        //       'Expect errors in decoding.'
        //   );
      }

      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

      do {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = enc1 << 2 | enc2 >> 4;
        chr2 = (enc2 & 15) << 4 | enc3 >> 2;
        chr3 = (enc3 & 3) << 6 | enc4;
        output += String.fromCharCode(chr1);

        if (enc3 != 64) {
          output += String.fromCharCode(chr2);
        }

        if (enc4 != 64) {
          output += String.fromCharCode(chr3);
        }

        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return unescape(output);
    }
    /**
     *
     * @param ssrlist
     *
     * Will return the reversed version of the array
     */

  }, {
    key: "reverseArray",
    value: function reverseArray(ssrlist) {
      if (!ssrlist) {
        return;
      }

      var reversedArray = ssrlist.reverse();
      return reversedArray;
    }
    /**
     *
     * @param ssrlist
     *
     * Will concatenate all the array elements
     */

  }, {
    key: "concatArrayElements",
    value: function concatArrayElements(ssrlist) {
      if (!ssrlist) {
        return;
      }

      var concatenatedArray = ssrlist.join('');
      return concatenatedArray;
    }
    /**
     *
     * @param ssrlist
     *
     * Will remove one extra character from each of the array elements
     */

  }, {
    key: "removeExtraChar",
    value: function removeExtraChar(ssrlist) {
      if (!ssrlist) {
        return;
      }

      var removedExtraCharSSRList = [];
      ssrlist.forEach(function (ssr) {
        if (!ssr) {
          return;
        }

        var removedCharSSR = ssr.substring(0, ssr.length - 1);
        removedExtraCharSSRList.push(removedCharSSR);
      });
      return removedExtraCharSSRList;
    }
    /**
     *
     * @param ssrlist
     * @param xPlace
     *
     * Will only include items that are not in multiples of xPlace
     */

  }, {
    key: "removeRandomStringAtXPlace",
    value: function removeRandomStringAtXPlace(ssrlist, xPlace) {
      if (!ssrlist) {
        return;
      }

      var removedExtraFromSSRList = [];

      for (var i = 0; i < ssrlist.length; i++) {
        if ((i + 1) % xPlace !== 0) {
          removedExtraFromSSRList.push(ssrlist[i]);
        }
      }

      return removedExtraFromSSRList;
    }
    /**
     *
     * @param ssrlist
     * @param xPlace
     *
     * Will only include items that are in multiples of xPlace
     */

  }, {
    key: "removeRandomOnlyAtXPlace",
    value: function removeRandomOnlyAtXPlace(ssrlist, xPlace) {
      if (!ssrlist) {
        return;
      }

      var removedExtraFromSSRList = [];

      for (var i = 0; i < ssrlist.length; i++) {
        if ((i + 1) % xPlace === 0) {
          removedExtraFromSSRList.push(ssrlist[i]);
        }
      }

      return removedExtraFromSSRList;
    }
    /**
     *
     * @param algorithmOrder
     * @param ssrlist
     *
     * Will execute the functions indicated in the algorithm array sequentially
     */

  }, {
    key: "executeAlgorithm",
    value: function executeAlgorithm(algorithmOrder, ssrlist) {
      var _this2 = this;

      if (!algorithmOrder || !ssrlist) {
        return;
      }

      var newSSRValue = null;

      var start = function start(index, value) {
        switch (algorithmOrder[index]) {
          case _modelsConstants.BASE64:
            newSSRValue = _this2.decode64(value);
            break;

          case _modelsConstants.REVERSE:
            newSSRValue = _this2.reverseArray(value);
            break;

          case _modelsConstants.ADD_EXTRA_CHAR:
            newSSRValue = _this2.removeExtraChar(value);
            break;

          case _modelsConstants.SPLIT_INTO_THREE:
          case _modelsConstants.SPLIT_INTO_FOUR:
            newSSRValue = _this2.concatArrayElements(value);
            break;

          case _modelsConstants.INSERT_RANDOM_AT_3:
            newSSRValue = _this2.removeRandomStringAtXPlace(value, _modelsConstants.ALGORITHM_INDEX);
            break;

          case _modelsConstants.INSERT_ONLY_AT_3:
          case _modelsConstants.INSER_ONLY_AT_3_WITH_3_CHAR:
            newSSRValue = _this2.removeRandomOnlyAtXPlace(value, _modelsConstants.ALGORITHM_INDEX);
            break;

          default:
            break;
        }

        index++;

        if (algorithmOrder.length > index) {
          start(index, newSSRValue);
        }
      };

      start(0, ssrlist);
      return "".concat(_modelsConstants.BEARER).concat(newSSRValue);
    }
    /**
     *
     * @param ssrDataTkns
     * @param ssrTknName
     *
     * Will get the specific token needed by a specific api
     */

  }, {
    key: "getSSRTkn",
    value: function getSSRTkn(ssrDataTkns, ssrTknName) {
      if (!ssrDataTkns || !ssrTknName) {
        return;
      }

      var ssrTkn;

      for (var key in ssrDataTkns) {
        if (key === ssrTknName) {
          ssrTkn = ssrDataTkns[key];
        }
      }

      return ssrTkn;
    }
    /**
     * Will check collectively if the JWT Tokens are
     * already set in the globals variable
     */

  }, {
    key: "verifySSRTknGlobals",
    value: function verifySSRTknGlobals(ssrDataTkn) {
      if (!ssrDataTkn) {
        return;
      }

      var areTokensSet = true;

      for (var key in ssrDataTkn) {
        /** Temporary Solution to avoid cases where page is not loading
         *  Final Fix: To be taken care of on Sprint 5
         */
        if (ssrDataTkn[key].length <= 0 && key !== _modelsConstants.SOURCE_KEYS.HOTEL_KEY) {
          areTokensSet = false;
        }
      }

      return areTokensSet;
    }
    /**
     *
     * @param channelDetails
     *
     * Will find the channel details for a shopping platform
     */

  }, {
    key: "findHash",
    value: function findHash(channelDetails, shoppingPlatform) {
      if (!channelDetails || !shoppingPlatform) {
        return;
      }

      var shoppingChannelDetails = channelDetails.find(function (channelDetail) {
        return channelDetail.Platform === shoppingPlatform;
      });

      if (!shoppingChannelDetails) {
        return;
      }

      var shoppingHash = shoppingChannelDetails.ChannelHash;
      return shoppingHash;
    }
  }]);
  return SSRDataUtilities;
}();

exports.SSRDataUtilities = SSRDataUtilities;